import React from "react";
import Topbar from "./Topbar";
import WishlistContent from "./WishlistContent";
import WishlistHeader from "./WishlistHeader";

const Favorites = ({ toggle }) => {
  return (
    <div
      className="fixed inset-0 w-screen h-screen bg-black/20"
      onClick={toggle}
    >
      <div
        className="relative w-screen h-screen flex flex-col items-center justify-center"
        onClick={toggle}
      >
        <div
          className="relative max-w-[1100px] w-full h-[90%] bg-white overflow-y-clip"
          aria-label="Modal"
          onClick={(e) => e.stopPropagation()}
        >
          {/* Topbar */}
          <Topbar toggle={toggle} />
          {/* Content */}
          <div className="relative w-full h-full flex flex-col grow">
            <WishlistHeader />
            <WishlistContent toggle={toggle} />
          </div>
        </div>
      </div>
    </div>
  );
};

export default Favorites;
